module.exports = __webpack_public_path__ + "img/edge_patrimoine_art.f8f0877a.svg";